import React, { useState, useEffect, useContext } from "react";
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import {
  getAllProjects,
  deleteProject,
  archiveProject,
} from "../../webServices/Apis";
import { FaTrash, FaPlus, FaEdit, FaEye, FaSearch } from "react-icons/fa";

import Loader from "../Loader/Loader";
import ProjectModal from "../Modals/ProjectModal";
import CustomModal from "../Modals/CustomModal";
import {
  message,
  Modal,
  Button,
  Form,
  Input,
  Select,
  Space,
  Pagination,
  DatePicker,
  Tooltip,
} from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import ReactReadMoreReadLess from "react-read-more-read-less";
import AddSubContracter from "./ProjectCrud/AddProject";
import AddProject from "./ProjectCrud/AddProject";
import ViewProject from "./ProjectCrud/ViewProject";
import EditProject from "./ProjectCrud/EditProject";
import DeleteTask from "./ProjectCrud/DeleteTask";
import { useNavigate } from "react-router";
import { UserContext } from "../../App";
import { HiArchiveBoxArrowDown } from "react-icons/hi2";

const { Option } = Select;
const { Search } = Input;

function Projects({ domains }) {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(UserContext);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddProject, setShowAddProject] = useState(false);
  const [action, setAction] = useState(false);
  const [showViewProject, setShowViewProject] = useState(false);
  const [selectedProject, setSelectedProject] = useState({});
  const [showEditProject, setShowEditProject] = useState(false);
  const [showTasks, setShowTasks] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showArchivedModal, setShowArchivedModal] = useState(false);
  const [allProjects, setAllProjects] = useState([])

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getAllProjectsApi = async () => {
    try {
      const response = await getAllProjects();
      if (response?.data?.success) {
        const notArchived = response?.data?.data?.filter(
          (data) => data?.isArchived !== true
        );
        const reverseProjects = [...notArchived].reverse();
        setProjects(reverseProjects);
        setAllProjects(response?.data?.data)
      }
    } catch (error) {
      console.log("Error fetching projects:", error);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        window.location.href = "/login";
        return;
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired");
        localStorage.clear();
        setIsAuthenticated(false);
        window.location.href = "/login";
        return;
      } else {
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllProjectsApi();
  }, [action]);

  const filteredProjects = projects.filter((project) => {
    const query = searchQuery.toLowerCase();
    return (
      (project.projectName &&
        project.projectName.toLowerCase().includes(query)) ||
      (project.projectAddress &&
        project.projectAddress.toLowerCase().includes(query)) ||
      (project.projectNumber &&
        project.projectNumber.toString().includes(query))
    );
  });
  // (typeof project.projectNumber === 'string' && project.projectNumber.toLowerCase().includes(searchQuery))
  // project.projectNumber.includes(searchQuery)

  const handleArchivedProject = (project) => {
    setSelectedProject(project);
    setShowArchivedModal(true);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleView = (project) => {
    setSelectedProject(project);
    setShowViewProject(true);
  };

  const handleEdit = (project) => {
    setSelectedProject(project);
    setShowEditProject(true);
  };

  const handleAddProject = () => {
    setShowAddProject(true);
  };

  const handleShowDeleteModal = (projectId) => {
    setProjectToDelete(projectId);
    setShowDeleteModal(true);
  };

  const handleDeleteProject = async () => {
    if (projectToDelete) {
      setLoading(true);
      try {
        const res = await deleteProject(projectToDelete);
        if (res.data.success) {
          message.success(res?.data?.message);
          setAction(!action);
          setShowDeleteModal(false);
          setProjectToDelete(null);
        }
      } catch (error) {
        message.error(
          error?.response?.data?.message || "Error while deleting the project"
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const hanldeTasks = (tasksList) => {
    setSelectedTasks(tasksList);
    setShowTasks(true);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }

  const currentItems = filteredProjects.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleArchiveProject = async (status) => {
    try {
      setLoading(true);

      const response = await archiveProject(status, selectedProject.id);

      if (response?.data?.success) {
        message.success(response?.data?.message);
        setShowArchivedModal(false);
        setAction(!action);
      }
    } catch (error) {
      console.log("Error while archive project", error);
      message.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

const handleNavigateArchive = async () => {
  navigate("/archived-projects", {state: {allProjects}})
}

  return (
    <div>
      {loading && <Loader />}

      <div className="p-4 overflow-y-auto">
        <div className="flex flex-row justify-between items-center">
          <div className="relative w-1/3 flex">
            <input
              type="text"
              placeholder="Search Project By Name..."
              className="w-3/4 p-3 border-4 border-gray-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              // value={searchQuery}
              onChange={handleSearch} // Update the state on input change
            />
            <FaSearch className="absolute left-2/3 top-3 text-gray-800 h-5 w-5 cursor-pointer mt-2  " />
          </div>
          <div className="flex justify-end gap-2">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded"
              onClick={handleAddProject}
            >
              Create Project
            </button>
            <Tooltip title="View Archived Project">
              <button
                className="bg-orange-500 hover:bg-blue-400 text-white font-bold py-2 px-6 rounded"
                onClick={handleNavigateArchive}
              >
                Archived Projects
              </button>
            </Tooltip>
          </div>
        </div>

        <table className="min-w-full bg-white border border-b-4 border-gray-800 mt-7">
          <thead>
            <tr className="bg-gray-800 text-white">
              {/* <th className="py-2 px-4 border-b text-center">Sr. No.</th> */}
              <th className="py-2 px-4 border-b text-center">Project Number</th>
              <th className="py-2 px-4 border-b text-center">Name</th>
              <th className="py-2 px-4 border-b text-center">Budget</th>
              <th className="py-2 px-4 border-b text-center">Address</th>
              <th className="py-2 px-4 border-b text-center">Start Date</th>
              <th className="py-2 px-4 border-b text-center">End Date</th>
              <th className="py-2 px-4 border-b text-center">Tasks</th>
              <th className="py-2 px-4 border-b text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((project, index) => (
                <tr
                  key={project.id}
                  className={`text-center transition ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-300"
                  }`}
                >
                  {/* <td className="py-2 px-4 border-b">{(currentPage - 1) * itemsPerPage + index + 1}</td> */}
                  <td className="py-2 px-4 border-b">
                    {project.projectNumber || "N/A"}
                  </td>
                  <td className="py-2 px-4 border-b">{project.projectName}</td>
                  <td className="py-2 px-4 border-b">{project.budget}</td>
                  <td className="py-2 px-4 border-b">
                    {project?.projectAddress?.length > 25
                      ? `${project?.projectAddress?.substring(0, 25)}...`
                      : project?.projectAddress}
                  </td>
                  <td className="py-2 px-4 border-b">
                    {project.projectStartDate
                      ? formatDate(project.projectStartDate)
                      : "N/A"}
                  </td>
                  <td className="py-2 px-4 border-b">
                    {project.dueDate ? formatDate(project.dueDate) : "N/A"}
                  </td>
                  <td className="py-2 px-4 border-b">
                    <button
                      onClick={() => hanldeTasks(project)}
                      style={{
                        background: "lightgreen",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "3px 10px",
                      }}
                    >
                      Edit Tasks
                    </button>
                  </td>
                  <td className="py-2 px-4 border-b justify-center w-1/6">
                    <button
                      onClick={() => handleView(project)}
                      className="mr-2 text-blue-500 hover:text-blue-700"
                    >
                      <AiOutlineEye className="text-2xl" />
                    </button>
                    <button
                      onClick={() => handleEdit(project)}
                      className="mr-2 text-blue-500 hover:text-blue-700"
                    >
                      <AiFillEdit className="text-2xl" />
                    </button>
                    <button
                      onClick={() => handleShowDeleteModal(project.id)}
                      className="mr-2 text-red-500 hover:text-red-700"
                    >
                      <AiFillDelete className="text-2xl" />
                    </button>
                    <Tooltip title="Mark project as archive">
                      <button
                        onClick={() => handleArchivedProject(project)}
                        className="mr-2 text-orange-500 hover:text-red-700"
                      >
                        <HiArchiveBoxArrowDown className="text-2xl" />
                      </button>
                    </Tooltip>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="py-2 px-4 border-b text-center">
                  No projects available
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {showAddProject && (
          <AddProject
            showAddProject={showAddProject}
            setShowAddProject={setShowAddProject}
            action={action}
            setAction={setAction}
            domains={domains}
          />
        )}

        {showViewProject && (
          <ViewProject
            showViewProject={showViewProject}
            setShowViewProject={setShowViewProject}
            selectedProject={selectedProject}
            domains={domains}
          />
        )}

        {showEditProject && (
          <EditProject
            showEditProject={showEditProject}
            setShowEditProject={setShowEditProject}
            selectedProject={selectedProject}
            action={action}
            setAction={setAction}
            domains={domains}
          />
        )}

        {showDeleteModal && (
          <CustomModal
            isOpen={showDeleteModal}
            title="Confirm Delete"
            onClose={() => setShowDeleteModal(false)}
            onConfirm={handleDeleteProject}
            message="Are you sure you want to delete this project ?"
          />
        )}

        {showTasks && (
          <DeleteTask
            action={action}
            setAction={setAction}
            showTasks={showTasks}
            setShowTasks={setShowTasks}
            selectedTasks={selectedTasks}
          />
        )}

        {showArchivedModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
              <h3 className="text-3xl font-bold mb-4 text-start text-black">
                Confirm Archive
              </h3>
              <p className="mb-4 text-start text-black">
                Are you sure you want to archive this project ?{" "}
              </p>
              <div className="flex justify-end gap-4">
                <button
                  onClick={() => {
                    setShowArchivedModal(false);
                  }}
                  className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleArchiveProject(true)}
                  className="bg-orange-400 text-white py-3 px-8 rounded-md mr-2 hover:bg-green-700 transition duration-200"
                >
                  Archive
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-end mt-4">
          <Pagination
            current={currentPage}
            onChange={handlePageChange}
            pageSize={itemsPerPage}
            total={filteredProjects.length}
          />
        </div>
      </div>
    </div>
  );
}

export default Projects;
